import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { PayrollPeriodIdSelect } from "../selects/PayrollPeriodIdSelect";

export function DeleteAllPayrollSummaryForm({
	isOpen,
	onClose,
	payrollPeriodId,
	setPayrollPeriodId,
	handleDelete,
}) {
	const [errorState, setErrorState] = useState(false);

	const submit = (e) => {
		if (!payrollPeriodId) {
			setErrorState(true);
			return;
		}
		handleDelete(e);
		handleClose();
		setErrorState(false);
	};

	const handleClose = () => {
		onClose();
		setPayrollPeriodId("");
		setErrorState(false);
	};

	return (
		<>
			<div className={`modal-overlay ${isOpen ? "open" : ""}`}>
				{isOpen && (
					<div className="modal">
						<div className="popUp-header row">
							<div className="popUp-title">
								<h3 style={{ color: "#668fca" }}>Delete!</h3>
							</div>
							<div className="popUp-close">
								<CloseIcon onClick={() => handleClose()} />
							</div>
						</div>
						<div
							className="popUp-body"
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
							}}
						>
							<div className="popUp-item info-item column">
								<div className="info-item-label">Payroll Period</div>
								<div className="info-item-input">
									<PayrollPeriodIdSelect
										payrollPeriodId={payrollPeriodId}
										setPayrollPeriodId={setPayrollPeriodId}
									/>
								</div>
								<span
									style={{
										visibility:
											!payrollPeriodId && errorState ? "visible" : "hidden",
										color: "#ff6565",
										fontSize: "12px",
									}}
								>
									Please fill up this field
								</span>
							</div>
						</div>
						<div
							className="buttons row"
							style={{
								justifyContent: "center",
								padding: "40px 40px 20px 40px",
							}}
						>
							<button
								id="add-family"
								className="save row"
								onClick={(e) => submit(e)}
								style={{ marginRight: "5px" }}
							>
								DELETE
							</button>
							<button
								id="add-family"
								className="cancel row"
								onClick={() => handleClose()}
							>
								CANCEL
							</button>
						</div>
					</div>
				)}
			</div>
		</>
	);
}